export const HIGHLIGHTER = {
  WIDTH: 340,
  HEIGHT: 40,
  MOBILE_WIDTH: 180,
  DEFAULT_INCREASE: 10,
  RADIUS: 40,
  MARGIN_DEFAULT: 20
};
